import { makeObservable, observable, action } from 'mobx';
import StopListRequests from 'Utils/Requests/StopListRequests';
import FiltersStore from 'Stores/StopList/FiltersStore';
import AppStore from "Stores/AppStore";

class StopListStore {
    selectedRecordsIds;
    initLoading;
    recordsLoading;
    records;
    totalRecordCount;
    sorting;
    processingRecordsIds;

    constructor() {
        makeObservable(this, {
            selectedRecordsIds: observable,
            initLoading: observable,
            recordsLoading: observable,
            records: observable,
            totalRecordCount: observable,
            processingRecordsIds: observable
        });
        this.tableStore = {};
        this.ClearStore();
    }

    ClearStore = action(() => {
        this.selectedRecordsIds = [];
        this.initLoading = true;
        this.recordsLoading = false;
        this.records = [];
        this.processingRecordsIds = [];

        this.pageToSet = 1;
    });

    RetrySendFromStopList() {
        this.retryOrCancelProcessing = true;
        this.processingRecordsIds = this.selectedRecordsIds;
        StopListRequests.Retry(this.selectedRecordsIds).then(_ => {
            this.selectedRecordsIds = [];
            this.processingRecordsIds = [];
            this.GetData();
            this.retryOrCancelProcessing = false;
        });
    }

    CancelSendFromStopList() {
        this.retryOrCancelProcessing = true;
        this.processingRecordsIds = this.selectedRecordsIds;
        StopListRequests.Cancel(this.selectedRecordsIds).then(_ => {
            this.selectedRecordsIds = [];
            this.processingRecordsIds = [];
            this.GetData();
            this.retryOrCancelProcessing = false;
        });
    }

    SetTableStore(store) {
        this.tableStore = store;
    }

    GetData = action((pageToSet) => {
        if (pageToSet)
            this.pageToSet = pageToSet;
        if (!this.pageToSet)
            this.pageToSet = 1;

        this.recordsLoading = true;
        let elementsPerPage = this.tableStore.paginationInfo.elementsPerPage;
        let start = (this.pageToSet - 1) * elementsPerPage;

        let filters = {
            ...FiltersStore.filters,
            start: start,
            length: elementsPerPage
        };

        StopListRequests.GetData(filters).then(action((values) => {
            if (!this.tableStore.HandlePagination(this.SetPageData, values.recordsFiltered, this.pageToSet, page => this.GetData(page)))
                return;

            this.records = values.data;
            this.totalRecordCount = values.recordsFiltered;

            this.tableStore.data = values.data;

            this.recordsLoading = false;
        }));
    });

    SetPageData(pageToSet) {
        window.history.pushState(null, "Стоп-лист", `${window.SmrLocation}/stopList?page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'stopList',
            params: {
                page: `${pageToSet}`
            }
        });
    }

    PrintStopListItem(id) {
        StopListRequests.PrintStoplistEntity(id);
    }

    SelectItemInTable = action((id, isSelect) => {
        this.SelectItemsInTable([id], isSelect);
    });

    SelectCurrentPageOfTable = action((isSelect) => {
        this.SelectItemsInTable(this.records.map(it => it.id), isSelect);
    });

    SelectItemsInTable = action((ids, isSelect) => {
        this.selectedRecordsIds = isSelect
            ? this.selectedRecordsIds.concat(ids.filter(id => this.selectedRecordsIds.some(itSelectedRecordId => itSelectedRecordId == id) == false))
            : this.selectedRecordsIds.filter(itSelectedRecordId => ids.some(id => id == itSelectedRecordId) == false);
    });
}

export default new StopListStore();